/**
 * @desc 重新获取walmart token
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.walmartOrder.getTokenInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/getTokenInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
